import React from 'react';
import { Image } from 'semantic-ui-react';
import { getCDNpath } from '../../../app/common/util';

const BankIcon = (props) => {
    const { bank } = props;
    const bankIcon = getCDNpath(`/static/images/banks/${bank.code}.png`);
    if (bank && bank.code) {
        return (
            <Image 
                className="bankIcon" 
                src={bankIcon} 
                alt={bank.name} 
                size="tiny"
                style={{float: 'right'}} 
            />
        );
    } else {
        return null;
    }
}

export default BankIcon;